<template>
    <div class="side-navigation" @click.stop>
        <div class="side-navigation--trigger" @click="toggle({ isOpen: !isOpen })">
            <hamburger>
                <slot name="trigger"/>
            </hamburger>
        </div>
        <transition name="trs-side-panel">
            <div class="side-navigation--panel" v-if="isOpen">
                <slot name="panel"/>
            </div>
        </transition>
    </div>
</template>

<script>
    import { add as addEvent, remove as removeEvent } from 'bianco.events';
    import { mapState, mapActions } from 'vuex';
    import Hamburger from '../../components/hamburger/hamburger';

    export default {
        components: { Hamburger },
        computed: {
            ...mapState('side-navigation', ['isOpen']),
        },
        methods: {
            ...mapActions('side-navigation', ['toggle']),
            onClickOutside() {
                this.toggle({ isOpen: false });
            },
        },
        mounted() {
            addEvent(window, 'click', this.onClickOutside);
        },
        beforeDestroy() {
            removeEvent(window, 'click', this.onClickOutside);
        },
    };
</script>
